<template>
<div class="contact-types-block">
    <vx-card title="Kiosk Settings" class="mb-6">
        <div class="vx-row">
            <div class="vx-col md:w-1/2">
                <div class="vx-con-field">
                    <div class="vs-con-input">
                        <vx-field type="v-select" class="w-full mb-3" label="Printers" v-model="data.printer" placeholder="-- No Printer --" :options="{
                                text: 'name',
                                items: printers.items || []
                            }"
                            :disabled="isArchivedLocation"
                            :key="componentKey"
                        >
                            <template slot="option" slot-scope="option">
                                <div class="vx-row">
                                    <div class="vx-col w-4/5">
                                        {{ option.name }}
                                    </div>
                                    <div class="vx-col w-1/5">
                                        <div class="vx-row w-full flex flex-row justify-center">
                                            <div class="vx-col">
                                                <template v-if="option.editable">
                                                    <feather-icon
                                                        class="editPrinter"
                                                        style="border: 4px"
                                                        icon="EditIcon"
                                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                                        @mousedown.stop.prevent="editPrinter(option)"
                                                    />
                                                    <feather-icon
                                                        icon="TrashIcon"
                                                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                                        class="deletePrinter ml-2"
                                                        @mousedown.stop.prevent="deletePrinter(option)"
                                                    />
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </vx-field>
                    </div>
                </div>

                <div v-if="data.printer && data.printer.proxyKey !== null" class="con-vs-alert v-enter-to" style="background-color: #eee;">
                    <div class="vs-alert text-black">
                        <p class="mb-4">The Proxy option is used to print from a tablet/iPad or to allow multiple kiosks running on different PC's to print to one
                            printer. <a href="#" @click.prevent="openPrinterSetup">Download the printer proxy here</a> and run this from the command line to set it up.</p>
                        <pre>timecloud-printer-proxy install {{ data.printer.proxyKey }}</pre>
                    </div>
                </div>
            </div>
            <div class="vx-col w-full md:w-1/2 mb-4 tooltip-holder">
                <div class="tooltip">
                    <p>No label printer is required. You can optionally print labels at check-in. These printer models are supported Dymo 450</p>
                </div>
            </div>
        </div>

        <div class="flex justify-between ">
            <vs-button class="mr-auto mt-3 vx-row__actions" @click.prevent="addPrinter()" icon-pack="feather" icon="icon-plus" icon-before :disabled="isArchivedLocation">Add Printer</vs-button>
            <vs-button class="ml-auto mt-3 vx-row__actions" @click.prevent="saveChanges()" icon-pack="feather" icon="icon-check" icon-before :disabled="isArchivedLocation">Save Changes</vs-button>
        </div>
    </vx-card>

</div>
</template>

<script>
import SetupPrinter from '@/components/tc-popup-content/SetupPrinter';

import vSelect from 'vue-select';
import {
    mapState
} from 'vuex';
export default {
    props: ['data', 'isArchivedLocation'],
    components: {
        vSelect
    },
    data() {
        return {
            componentKey: 0,
        };
    },
    computed: {
        ...mapState('visitManagement', ['printers', 'printer'])
    },
    watch: {
        printer: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.data.printer = newVal.name;
                this.componentKey += 1;
            }
        }
    },
    methods: {
        async filter() {
            await this.$store.dispatch('visitManagement/fetchPrinters');
        },
        saveChanges() {
            let data = this.data;
            if (data.printer !== null && typeof data.printer === "string") {
                data.printer = this.printer;
            }

            this.$store
                .dispatch('visitManagement/updateLocation', {
                    ...data,
                    printer: {
                        ...(!data.printer ? {
                            id: null
                        } : data.printer)
                    }
                })
                .then(res => {
                    this.$emit('success', res.data)
                    console.log(res);
                });
        },
        openPrinterSetup() {
            this.$root.$tcPopup.show({
                data: this.data.printer,
                classes: 'vs-dialog--md',
                title: `Setup Printer`,
                component: SetupPrinter,
                buttonsHidden: true
            })
        },
        editPrinter(printer) {
            this.$root.$tcPopup.show({
                data: printer,
                classes: 'vs-dialog--md',
                title: `Edit Printer`,
                component: 'FormPrinter',
                acceptText: 'Save Changes'
            })
        },
        async deletePrinter (printer) {
            await this.$store.dispatch('visitManagement/deletePrinterById', printer.id).then(() => {
                this.data.printer = null;
            });
        },
        addPrinter() {
            this.$root.$tcPopup.show({
                data: {},
                classes: 'vs-dialog--md',
                title: 'New Printer',
                component: 'FormPrinter',
                acceptText: 'Save'
            })
        },
    },
    async created() {
        await this.filter();
    }
};
</script>
